export const INITIAL_STEP = 'Thinking...';
export const EDITOR_WRITE_STEP = 'Editing document...';

type ToolProgressActivityState = 'thinking' | 'reading' | 'writing';

type ToolSessionMetadata = {
  activityState: ToolProgressActivityState;
  step: string;
  allowProgressEvent: boolean;
};

const TOOL_SESSION_METADATA = {
  tiptapRead: {
    activityState: 'reading',
    step: 'Reading document...',
    allowProgressEvent: true,
  },
  tiptapReadSelection: {
    activityState: 'reading',
    step: 'Reading selection...',
    allowProgressEvent: true,
  },
  getDocumentContext: {
    activityState: 'thinking',
    step: 'Getting context...',
    allowProgressEvent: true,
  },
  tiptapEdit: {
    activityState: 'writing',
    step: EDITOR_WRITE_STEP,
    allowProgressEvent: false,
  },
  replaceSelection: {
    activityState: 'writing',
    step: EDITOR_WRITE_STEP,
    allowProgressEvent: false,
  },
  setDocumentName: {
    activityState: 'thinking',
    step: 'Naming document...',
    allowProgressEvent: true,
  },
} as const satisfies Record<string, ToolSessionMetadata>;

type AgentToolName = keyof typeof TOOL_SESSION_METADATA;

function getToolName(toolType: string): AgentToolName | null {
  const toolName = toolType.replace(/^tool-/, '');

  return toolName in TOOL_SESSION_METADATA ? (toolName as AgentToolName) : null;
}

export function getToolSessionMetadata(toolType: string): ToolSessionMetadata | null {
  const toolName = getToolName(toolType);
  return toolName ? TOOL_SESSION_METADATA[toolName] : null;
}
